module.exports = __webpack_public_path__ + "img/android.14ed07e6.svg";